// Cross-bundler config helper that works on both CRA and Vite
export const CFG = {
  LIFF_ID:
    process.env.REACT_APP_LIFF_ID ||
    '',
  REDIRECT_URI:
    process.env.REACT_APP_REDIRECT_URI ||
    '',
  LIFF_SCOPE:
    process.env.REACT_APP_LIFF_SCOPE || 
    'profile openid email',
  LIFF_PROMPT:
    process.env.REACT_APP_LIFF_PROMPT || 
    'consent',
  API_BASE:
    process.env.REACT_APP_API_BASE ||
    '',
};

export function assertEnv() {
  if (!CFG.LIFF_ID) throw new Error('Missing LIFF_ID from env');
  if (!CFG.REDIRECT_URI) throw new Error('Missing REDIRECT_URI from env');
  if (!CFG.API_BASE) throw new Error('Missing API_BASE from env');
}